
















import { Component, Vue } from 'vue-property-decorator';
import ServiceRequestDetails from '../ServiceRequestDetails.vue';
import '../../assets/css/ServiceRequestDetails.scss';
@Component({
    components: {
        ServiceRequestDetails,
    },
})
export default class ViewRequestDetailModal extends Vue {

    private show = true;
    private id: string = '';

    private mounted() {
        this.id = this.$route.params.id;
    }

    private close() {
        this.$router.back();
    }
}
